import axios, { microServices } from './axios'
import { loaders } from './../constants'

// // ********************API url *******************
const GET_USERS_LIST = '/user/list'
const SAVE_USER_ROLE = '/role/add'
const ADD_USER = '/user/register'
const GET_ROLES_LIST = '/role/list'
const GET_USER_DATA = '/user/profile'
const GET_USER = '/user/detail'
const LOG_IN = '/login'
const LOG_OUT = '/logout'
const UPDATE_PROFILE = '/profile/update'
const UPDATE_PASSWORD = '/profile/password'
const UPDATE_USER = '/user/update'
const DELETE_ROLE = '/role'
const GET_USER_NAMES = '/user/names/list'
const FORGOT_PASSWORD = '/user/forgot-password'
const DELETE_USERS = '/user'
const GET_ACTIVE_USER = '/user/active/list'
const UPDATE_USER_ROLE = '/user/role'
const VERIFY_PASSWORD = '/user/verify-password'

// // ************API call Functions starts here **************

export const verifyPassword = async (data) => {
  return await axios('post', VERIFY_PASSWORD, data, { server: microServices.DE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const deleteRole = async (id) => {
  return await axios('delete', `${DELETE_ROLE}/${id}`, {}, { successMessage: 'User Role Deleted Successfully', server: microServices.DE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}


export const editUserRole = async (data, id) => {
  return await axios('put', `${DELETE_ROLE}/${id}`, data, { successMessage: 'User Role Updated Successfully', server: microServices.DE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const saveUserRole = async (data) => {
  return await axios('post', SAVE_USER_ROLE, data, { successMessage: 'Role Created Successfully', server: microServices.DE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const addUser = async (data) => {
  return await axios('post', ADD_USER, data, { successMessage: 'User Created Successfully', server: microServices.DE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const getUserList = async (params) => {
  return await axios('get', GET_USERS_LIST, {}, { server: microServices.DE, params }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const getRolesList = async () => {
  return await axios('get', GET_ROLES_LIST, {}, { server: microServices.DE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

/**
 * Submits user login credentials to authenticate and establish a session.
 *
 * @param {object} data - Credentials payload containing email and password
 * @returns {Promise<object>} User session data and auth token
 */
export const login = (data) => {
  return axios('post', LOG_IN, data, { server: microServices.DE })
}

/**
 * Terminates user session on the current client or across all devices.
 *
 * @param {object} [options] - Logout configuration options
 * @param {boolean} [options.allDevices=false] - Whether to revoke sessions across all devices
 * @returns {Promise<object>} Logout confirmation response
 */
export const logout = ({ allDevices = false } = {}) => {
  return axios('post', LOG_OUT, { allDevices }, { server: microServices.DE })
}

/**
 * Retrieves the currently authenticated user's profile and account metadata.
 *
 * @returns {Promise<object>} Current user profile data
 */
export const getUserData = () => {
  return axios('get', GET_USER_DATA, {}, { server: microServices.DE })
}

/**
 * Initiates an impersonation session for a designated user ID.
 *
 * @param {string} id - UUID of the user to impersonate
 * @returns {Promise<object>} Impersonated user session data
 */
export const impersonateUserData = (id) => {
  return axios('post', `${GET_USER_DATA}/${id}`, {}, { server: microServices.DE })
}

export const getUser = async (id) => {
  return await axios('get', `${GET_USER}/${id}`, {}, { server: microServices.DE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const updateProfile = async (data) => {
  return await axios('put', UPDATE_PROFILE, data, { /* successMessage: 'Profile Updated Successfully', */ server: microServices.DE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const updatePassword = async (data) => {
  return await axios('put', UPDATE_PASSWORD, data, { successMessage: 'Password Updated Successfully', server: microServices.DE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const editUser = async (data, id) => {
  return await axios('put', `${UPDATE_USER}/${id}`, data, { successMessage: 'User Updated Successfully', server: microServices.DE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const getUserNames = async () => {
  return await axios('get', GET_USER_NAMES, {}, { server: microServices.DE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const forgetPassword = async (data) => {
  return await axios('post', FORGOT_PASSWORD, data,
    {
      server: microServices.DE,
      loader: loaders.OVERLAY,
      successMessage: 'Forgot password link will be sent to registered email.'
    }).then(data => {
      return data
    },
      error => { // request level error
        return new Promise((resolve, reject) => {
          reject(error)
        })
      })
}

export const deleteUser = async (id) => {
  return await axios('delete', `${DELETE_USERS}/${id}`, {}, { successMessage: 'User Deleted Successfully', server: microServices.DE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const getActiveUser = async () => {
  return await axios('get', GET_ACTIVE_USER, {}, { server: microServices.DE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const updateUserRoles = async (data, id) => {
  return await axios('put', `${UPDATE_USER_ROLE}/${id}`, data, { server: microServices.DE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}
